import { useRef, type ReactNode } from 'react';
import { AsciiSkeleton } from '@/lib/ascii-dither/skeleton';
import { DitherLoadingContext } from './dither-loading-context';
import './dither-loading.css';

/** Selected treatment, scoped to course Desk and home reads. */
export function DitherLoading({ children }: { children: ReactNode }) {
  const settled = useRef(new Set<string>());
  return <DitherLoadingContext.Provider value={settled.current}>{children}</DitherLoadingContext.Provider>;
}

export function DitherSkeleton({ className }: { className?: string }) {
  return <AsciiSkeleton variant="dither" alphabet="arabic" lines={1} widths={['100%']} className={className} />;
}

export function DitherReadSkeleton({ covers = false }: { covers?: boolean }) {
  return covers ? <div className="native-dither-covers" aria-hidden="true">{[1, 2, 3].map(seed => <div key={seed}>
    <AsciiSkeleton variant="dither" alphabet="arabic" rows={12} height={160} seed={seed} />
    <AsciiSkeleton variant="dither" alphabet="arabic" lines={2} widths={['85%', '60%']} seed={seed} />
  </div>)}</div> : <div className="native-dither-rows" aria-hidden="true">{[1, 2, 3].map(seed => <AsciiSkeleton key={seed} variant="dither" alphabet="arabic" lines={2} widths={['85%', '45%']} seed={seed} />)}</div>;
}
